module.exports = __webpack_public_path__ + "static/img/ent-detail-98.d29b1f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-98.jpg
// module id = vPKC
// module chunks = 51